import "../../../../src/content/fountain-hills-streaming/fh-streaming.scss";
import * as React from 'react';
export default {
  React
};